import { useState } from "react";
import { avatarstylesxx } from "../../styling/global";
import IMGBG2 from "../../../assets/images/core/home/mobile/bg2.png"
import IMGBG3 from "../../../assets/images/core/home/mobile/bg3.png"
import BookSave from '../../../assets/images/icons/book-saved.png';
import Upload from '../../../assets/images/icons/upload.png';


export const HomeStates = () => {
    const [my, setMy] = useState({toggled: null, trainings: {all: 0, completed:0, enrolled:0, ongoing: 0 }, cpd: {all: 0.0, acd: 0.0, other: 0.0}, certificate: {all: 0, nearly: 0, expiry: 0}});
    const [form, setForm] = useState({
        toggled: false,
        method: null,
        step: 1,
        inputs: {
            certid: null,
            profession: {value: '', stat: false, msg: ''},
            title: {value: '', stat: false, msg: ''},
            dot: {value: '', stat: false, msg: ''},
            type: {value: '', toggled: false, stat: false, msg: ''},
            cpd: {value: '1.5', stat: false, msg: ''},
            ca: {value: '', stat: false, msg: ''},
            file: {value: null, object: null, name: 'default_avatar', type: 'default', size: 0, updated: false, stat: false, msg: ''}
        }
    })
    const [isContentLoader, setIsContentLoader] = useState(true);
    const [dau, setDAU] = useState({total: 0, external: 0, internal: 0});
    const [training, setTraining] = useState({total: 0, cs: 0, ts: 0});
    const [course, setCourse] = useState({total: 0, cs: 0, ts: 0});
    const [speaker, setSpeaker] = useState({total: 0, external: 0, internal: 0});
    const [acd, setAcd] = useState({view:'topic', iscroll: false, topic: [], exam:[]});
    const [graph, setGraph] = useState({topic:{title: 'topic', completed: 0, ongoing:0, enrolled: 0}, exam:{title: 'topic', passed: 0, failed:0, ongoing: 0}});

    //UserSide ===========================================
    const [categories, setCategories] = useState({personal: null, business: null})
    const [selected, setSelected] = useState(null)
    //DAILY ACTIVE USER

    // loader para sa pagination ng userAction
    const [loaded, setLoaded] = useState(false);

    // anchors
    const [cpdAnchorEl, setCPDAnchorEl] = useState(null);
    const [certAnchorEl, setCertAnchorEl] = useState(null);
    // const [my, setMy] = useState({toggled: null, certificates: {active: 0, value: 0, expired:0, nearlyEx:0}, cpd: {active: 0, all: 0.0, acd: 0.0, other: 0.0, value: 0.0}});
    const [vd, setVD] = useState({view:'acd', iscroll: false, acd: [], other:[]});
    const [ca, setCA] = useState([]);
    const [anchors, setAnchors] = useState({cpd: null, cert: null})
    const [ua, setUa] = useState({
        list: [
            { state:'acd', links: '/trainings/cpd' , name:'take-course', sx: avatarstylesxx(IMGBG2, '100%', '100%', '16px', 'right bottom', '93px 80px'), icon: BookSave, title: 'Take a Course' , description: 'Learn new topics that will help you in your quiz to become an extraordinary professional. ' },
            { state:'other',links: '/certificates/others' , name:'upload-certificate', sx: avatarstylesxx(IMGBG3, '100%', '100%', '16px', 'right bottom', '93px 80px'), icon: Upload, title: 'Upload a Certificate' , description: 'Keep track of your certificate and your CPD Credits.'},
            
            // { links: '/' , name:'take-course', icon: BookSave, title: 'Take a Course' , description: 'Learn new topics that will help you in your quiz to become an extraordinary professional. ' },
            // { links: '/trainings/cpd' , name:'take-course', icon: BookSave, title: 'Take a Course' , description: 'Learn new topics that will help you in your quiz to become an extraordinary professional. ' },
            // { links: '/certificates/others' , name:'upload-certificate', icon: Upload, title: 'Upload a Certificate' , description: 'Keep track of your certificate and your CPD Credits.'},
            // { links: '/' , name:'trainer', icon: Trainer, title: 'Be a Trainer' , description: 'keep track of your certificate and your CPD Credits.'},
            // { links: '/' , name:'complete-course', icon: BookComplete, title: 'Complete a Course' , description: 'Continue your quiz to become extraordinary.'},
        ],
        current: 0
    });

    const [userA, setuserA] = useState({acd:0, other: 0, total: 0 });



    return {
        my: {data: my, set: setMy},
        form: {data: form, set: setForm},
        dau: {data: dau, set: setDAU},
        training: {data: training, set: setTraining},
        course: {data: course, set: setCourse},
        speaker: {data: speaker, set: setSpeaker},
        acd: {data: acd, set: setAcd},
        graph: {data: graph, set: setGraph},
        isContentLoader: {data: isContentLoader, set: setIsContentLoader},
        categories: {data: categories, set: setCategories},
        selected: {data: selected, set: setSelected},
        vd: {data: vd, set: setVD},
        ua:{ data: ua, set: setUa },
        loaded: {data: loaded, set: setLoaded},
        anchors: {data: anchors, set: setAnchors},
        certAnchorEl: {data: certAnchorEl, set: setCertAnchorEl},
        cpdAnchorEl: {data: cpdAnchorEl, set: setCPDAnchorEl},
        ca: {data: ca, set: setCA},
        userA: {data: userA, set: setuserA},
    }
}